<div class="container-fluid" id="mainContainer-dashboard">

    <div (click)="onClickBack()" style="font-size: 14px; margin-bottom: 5px;  cursor: pointer;">
        <img src="this.src='../../../../../../assets/icons/back.png" style="width: 20px;"
            onError="this.src='../../../../../../assets/icons/back.png'" />
        Back
    </div>
    <div class="col-md-3" id="leftCol">

        <div class="Heading">
            Reports - Sales Report
        </div>

    </div>

    <div class="row" style="margin: 0px;">
        <div class="col-md-12" style="display: flex; justify-content: space-between; padding: 0; align-items: center;">
            <div class="col-md-6 filter-btn" appShowHide>
                <button type="button" class="btn-filter" data-toggle="collapse" data-target="#filterCollapse"
                    aria-expanded="false" aria-controls="collapseExample" (click)="loadFilters()">
                    <img src="../../../../../assets/icons/filter.png" id="navitem" width="16px" height="16px" alt=""
                        loading="lazy" style="margin: 0px 5px ;">
                    Filters
                </button>
            </div>

            <div [ngClass]="loggedUserRole == 4 ? 'col-md-12 filterDays': 'col-md-6  daysFilter'">
                <div class="col-md-8 filter-dashboard" id="filter-month-selector">
                    <div>
                        <button (click)="selectorPressed(1)"
                            [ngClass]="selectorActive === 1  ? 'leftFilter-active' : 'leftFilter-inactive'"
                            (click)="todayPressed()" type="submit">Today</button>
                    </div>
                    <div>
                        <button (click)="selectorPressed(2)"
                            [ngClass]="selectorActive === 2  ? 'middleFilter-active' : 'middleFilter-inactive'"
                            type="submit">Yesterday</button>
                    </div>
                    <div>
                        <button (click)="selectorPressed(3)"
                            [ngClass]="selectorActive === 3  ? 'middleFilter-active' : 'middleFilter-inactive'"
                            type="submit">Last 7
                            days </button>
                    </div>
                    <div>
                        <button (click)="selectorPressed(4)"
                            [ngClass]="selectorActive === 4  ? 'rightFilter-active' : 'rightFilter-inactive'"
                            type="submit">Last
                            Month</button>
                    </div>

                    <form [formGroup]="dateForm">
                        <div class="datepicker">
                            <input id="startDate" type="text" placeholder="Custom" class="form-control datepicker-input"
                                bsDaterangepicker [(ngModel)]="selectedStartDate" style="cursor: pointer;"
                                formControlName="date"
                                [bsConfig]="{ adaptivePosition: true,dateInputFormat:'YYYY-MM-DD'}"
                                [bsConfig]="bsConfig" (ngModelChange)="updateMyDate($event)" placement="bottom right">
                            <span id="iconCalendar">
                                <img src="../../../../../assets/icons/calendar.png" width="18px" height="18px"
                                    class="d-inline-block align-top" alt="" loading="lazy">
                            </span>

                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>


    <div class="collapse" id="filterCollapse">
        <div class="filterCol">
            <form [formGroup]="filterForm" id="filterForm">
                <div [ngClass]="loggedUserRole == 1 || loggedUserRole == 2 ? 'filtersBox' : 'filtersBoxAdmin' ">
                    <label class="filterLbl" for="menuName">Admin Filters</label>
                    <div class="row filtersRow">
                        <div [ngClass]="loggedUserRole == 1 || loggedUserRole == 2 ? 'superAdmin' : 'admin' ">
                            <label class="lblInput" for="menuName">Franchise</label>
                            <div class="filterInput">
                                <select class='form-control bulkInput selectpicker' id="spicker_franchise"
                                    (ngModelChange)="selectFranchise($event)" formControlName="franchise"
                                    data-style="dropdownCustomStyle">
                                    <option disabled value='' selected *ngIf='selectedFilterFranchise == "null"'
                                        data-content="<span class='text-secondary'>Nothing Selected</span>">Nothing
                                        Selected</option>
                                    <option *ngFor="let franchise of franchises" [ngValue]="franchise.id">
                                        {{franchise.name}} </option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <label class="lblInput" for="menuName">Outlet</label>
                            <div class="filterInput2">
                                <select class='form-control bulkInput selectpicker' id="spicker_shop"
                                    formControlName="shop" (ngModelChange)="selectShop($event)"
                                    data-style="dropdownCustomStyle" disabled="!showShops">
                                    <option selected value='' disabled *ngIf='selectedFilterFranchise == "null"'
                                        data-content="<span class='text-secondary'>Nothing Selected</span>">Nothing
                                        Selected</option>
                                    <option *ngFor="let shop of shops" [ngValue]="shop.id">
                                        {{shop.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>

</div>


<div class="container-responsive" [ngClass]="!isFilterClicked ? 'filterNotClicked' : 'filterClicked'">
    <div class="container-fluid cardContainer">
        <div class="row cardRow">
            <div class="cardBox">
                <div class="row" style="margin: 0; justify-content: space-between;">
                    <div class="cardText">Gross revenue</div>
                    <div class="cardText">{{currency}} {{grossRevenue}}</div>
                    <div style="width:100%">
                        <div class="progress-bar-container">
                            <div class="progress-bar {{'new'}}" [ngStyle]="{'width': grossRevenuePercentage + '%'}">
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div class="cardBox">
                <div class="row" style="margin: 0; justify-content: space-between;">
                    <div class="cardText">Net revenue</div>
                    <div class="cardText">{{currency}} {{netRevenue}}</div>
                    <div style="width:100%">
                        <div class="progress-bar-container">
                            <div class="progress-bar {{'completed'}}" [ngStyle]="{'width': netRevenuePercentage + '%'}">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="cardBox">
                <div class="row" style="margin: 0; justify-content: space-between;">
                    <div class="cardText">Canceled revenue</div>
                    <div class="cardText">{{currency}} {{cancelledRevenue}}</div>
                    <div style="width:100%">
                        <div class="progress-bar-container">
                            <div class="progress-bar {{'canceled'}}"
                                [ngStyle]="{'width': cancelledRevenuePercentage + '%'}">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="container-fluid mainContainerCharts">
        <div class="row graphRow">
            <div class="graphContainer">
                <div *ngIf="!isDataLoaded" class="item">
                    <ngx-skeleton-loader class="skelton-best-selling" count="1" [theme]="{ 
                    'border-radius': '6px',
                    height: '350px'
                  }"></ngx-skeleton-loader>
                </div>
                <div *ngIf="isDataLoaded">
                    <div class="graphHeader">Sales Overview</div>
                    <div>
                        <div style="display: block">
                            <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels"
                                [options]="barChartOptions" [plugins]="barChartPlugins" [legend]="barChartLegend"
                                [chartType]="barChartType">
                            </canvas>
                        </div>
                    </div>
                </div>

            </div>

            <div class="rightContainer">
                <div>
                    <div class="item-list">

                        <div *ngIf="!isDataLoaded" class="item">
                            <ngx-skeleton-loader class="skelton-best-selling" count="5" [theme]="{ 
                        'border-radius': '6px',
                        height: '30px'
                      }"></ngx-skeleton-loader>
                        </div>
                        <ng-container *ngIf="isDataLoaded && bestSellingProducts.length!=0; else elseBlock">
                            <div>
                                <div class="item-high">
                                    <div class="tag">
                                    </div>

                                </div>
                            </div>
                        </ng-container>
                        <ng-template #elseBlock>
                            <div *ngIf="isDataLoaded">
                            </div>
                        </ng-template>


                    </div>

                </div>
            </div>

        </div>
    </div>
</div>